import { useRouteError } from "react-router"
import EnkPageContainer from "../components/page-container"

export default function EnkErrorPage() {
  interface RouteError {
    statusText?: string
    message?: string
  }

  const error = useRouteError() as RouteError
  console.error(error)

  return (
    <EnkPageContainer>
      <div id="error-page">
        <h1>Oops!</h1>
        <p>Sorry, er is een onverwachte fout opgetreden</p>
        <p>
          <i>{error.statusText || error.message}</i>
        </p>
      </div>
    </EnkPageContainer>
  )
}
